import { z } from "zod";
import { DESCRIPTION, FILE, SHOW_TO_CUSTOMER } from "./consts";

export const schema = z.object({
  [FILE]: z.any(),
  [DESCRIPTION]: z.string().optional(),
  [SHOW_TO_CUSTOMER]: z.boolean().optional(),
});

export type formValues = z.infer<typeof schema>;
